<template>
  <v-app-bar color="#00b888" dense dir="rtl">
    <v-img src="./../assets/img/logo-small.png"></v-img>
  </v-app-bar>
  <v-container dir="rtl">
    <v-card class="mx-auto" max-width="800">
      <v-card-title style="background: #00b888; padding: 20px">
        ارتباط مستقیم با مدیر حوزه علمیه خراسان
      </v-card-title>
      <v-card-text
        style="border: 1px solid #999; border-top: none; padding: 15px"
      >
        <v-form ref="form" @submit.prevent="submitForm">
          <v-row justify="space-between">
            <v-col cols="12" md="12">
              <v-text-field v-model="code" label="کد پیگیری"></v-text-field>
            </v-col>
          </v-row>
          <v-row justify="space-between">
            <span style="margin: 20px">
              <img :src="captchaUrl" style="float: right" />
              <v-icon
                @click="generateCaptcha"
                style="font-size: 36px; margin-right: 20px; color: gray"
              >
                mdi-refresh
              </v-icon>
            </span>
          </v-row>
          <v-row justify="space-between">
            <v-col md="4" sm="12">
              <v-text-field
                v-model="captcha"
                label="کد امنیتی را وارد نمایید"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-btn
                type="submit"
                color="success"
                width="100%"
                style="
                  background: rgb(0 184 136) !important;
                  display: inline-block;
                  width: 49%;
                "
              >
                جستجو
              </v-btn>
              <a
                href="/"
                class="my-font"
                style="
                  width: 50%;
                  display: inline-block;
                  text-align: center;
                  padding: 8px;
                  background: #bd8282;
                "
                >انصراف</a
              >
            </v-col>
          </v-row>
          <v-row v-if="response">
            <fieldset
              style="
                color: blue;
                padding: 15px;
                margin: 10px 0px;
                text-align: justify;
                width: 100%;
                border: 1px solid #999;
                border-radius: 5px;
              "
              v-if="this.result.comment"
            >
              <legend>{{ this.result.D_date }}</legend>
              {{ this.result.comment }}
            </fieldset>
            <fieldset
              style="
                color: green;
                padding: 15px;
                margin: 10px 0px 20px 0px;
                text-align: justify;
                border: 1px solid #999;
                border-radius: 5px;
              "
            >
              <legend v-if="this.result.Reply">
                {{ this.result.D_Reply }}
              </legend>
              <span v-if="this.result.Reply">
                {{ this.result.Reply }}
              </span>
              <span v-if="!this.result.Reply">
                به درخواست شما هنوز پاسخی داده نشده است
              </span>
            </fieldset>
          </v-row>
          <v-row>
            <v-snackbar
              v-model="snackbar"
              :color="snackbarColor"
              absolute
              right
              rounded="pill"
              top
            >
              {{ text }}
              <template v-slot:action="{ attrs }">
                <v-btn
                  color="black"
                  text
                  v-bind="attrs"
                  @click="snackbar = false"
                >
                  Close
                </v-btn>
              </template>
            </v-snackbar>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "SearchPage",
  data() {
    return {
      inputValue: null,
      captchaText: "",
      captchaUrl: "",
      snackbar: false,
      snackbarColor: "red accent-2",
      code: "",
      result: [],
      response: false,
      formData: new FormData(),
      captcha: "",
    };
  },
  
  mounted() {
    this.generateCaptcha();
  },
  methods: {
   
    async sendForm() {
      this.formData = new FormData();

      this.formData.append("code", Number(this.code));
      this.formData.append("captchaInput", this.captcha);
      this.formData.append("captchaText", this.captchaText);
      return await axios
        .post(process.env.VUE_APP_API_ENDPOINT + "api/comment/search", this.formData)
        .then((res) => {
          if (res.data.Success) {
            this.sendComment = true;
            this.result = JSON.parse(res.data.Message);
            this.response = true;
            this.formData = new FormData();
            this.generateCaptcha()
            this.code= ""
          } else {
            this.snackbar = true;
            this.text = res.data.Message;
            this.snackbarColor = "red accent-2";
            this.generateCaptcha()
          }
        });
    },
    submitForm() {
      if (!this.captcha.length) {
        this.snackbar = true;
        this.text = "کد امنیتی را صحیح وارد نمایید";
        this.snackbarColor = "red accent-2";
        return false;
      }
      if (this.code == "") {
        this.snackbar = true;
        this.text = "وارد کردن کد پیگیری الزامی است";
        this.snackbarColor = "red accent-2";
        return false;
      }
      this.sendForm();
    },
    async generateCaptcha() {
      return await axios
        .get(process.env.VUE_APP_API_ENDPOINT + "captcha/gettext")
        .then((res) => {
          if (res.status != 200) {
            this.snackbar = true;
            this.text = "خطا در تولید کد امنیتی";
            this.snackbarColor = "red accent-2";
            
          } else {
            this.captchaText = res.data;
            this.getCaptchaImage();
            
          }
        });
    },
    async getCaptchaImage() {
      const url =
        process.env.VUE_APP_API_ENDPOINT +
        "captcha/show?text=" +
        this.captchaText;
      const response = await axios.get(url, { responseType: "arraybuffer" });
      if (response.status == 200) {
        const b64 = btoa(String.fromCharCode(...new Uint8Array(response.data)));
        const imgData =
          "data:" + response.headers["content-type"] + ";base64," + b64;

        this.captchaUrl = imgData;
      }
    },
  },
};
</script>
